export default __webpack_public_path__ + "static/media/backArrow.8f4f8061.svg";